import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { colors } from 'utils/colors';
import { Modal, Button } from 'components';
import { Icon } from 'semantic-ui-react';
import { Storage } from 'actions';
import { connect } from 'react-redux';

// eslint-disable-next-line react/prefer-stateless-function
class DeleteWarningModal extends Component {
  handleButtonClick = () => {
    const { dispatch } = this.props;
    dispatch(Storage.setItem('blueprintDeleteWarningSuppress', true));
    this.props.changeModalVisibility(false);
  };

  render() {
    const { isOpen, changeModalVisibility, isSavedBlueprint } = this.props;

    return (
      <Modal
        basicTop
        open={isOpen}
        dimmerClick={() => changeModalVisibility(false)}
      >
        <Modal.Content>
          <span style={{ width: '48rem', fontSize: '1.2rem' }}>
            <Icon name="lightbulb outline" style={{ fontSize: '1.2rem' }} />
            {!isSavedBlueprint
              ? 'If you change the inputs in this section, you will be required to re-estimate your Target Wealth and Target Saving in the next steps. You may wish to save your current Retirement Blueprint first in the "Summary" section.'
              : 'If you change the inputs in this section, you will be required to re-estimate your Target Wealth and Target Saving in the next steps.'}
          </span>
          <div
            className="button-div"
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '2rem',
            }}
          >
            <Button
              color={colors.green}
              icon="check"
              className="left"
              onClick={this.handleButtonClick}
              isQM
            >
              Do not show again
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

DeleteWarningModal.propTypes = {
  dispatch: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  changeModalVisibility: PropTypes.func.isRequired,
  isSavedBlueprint: PropTypes.bool,
};
DeleteWarningModal.defaultProps = {
  isSavedBlueprint: false,
  dispatch: () => false,
};

export default connect(() => ({}))(DeleteWarningModal);

// const CustomModal = styled(Modal)`
//   &.basicTop {
//     font-size: 1.2rem;
//     width: fit-content !important;
//     top: 20%;
//     left: 11%;

//     .modal-content {
//       text-align: center;
//       display: flex;
//       flex-direction: column;
//       gap: 2rem;
//       padding: 3rem 2rem;
//       position: relative;
//     }

//     .button-div {
//       display: flex;
//       justify-content: center;
//     }

//     button {
//       margin-top: 2rem;
//       color: ${colors.white} !important;
//       background-color: ${colors.red};
//       text-align: center;
//       width: 120px;
//       font-size: 1.2rem;
//     }
//   }
// `;
